import React from "react";
import EmployeeReports from "./EmployeeReports";

export default function NominalRoll() {
  return <EmployeeReports />;
}
